export default {
  setBaseList(state, payload) {
    state.baseList = payload;
  },
  setCurrentBases(state, payload) {
    state.currentBases = payload;
  },
};
